import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["notice", "alert"]
  static values = { notice: String, alert: String }

  declare readonly noticeTarget: HTMLElement
  declare readonly alertTarget: HTMLElement
  declare readonly noticeValue: string
  declare readonly alertValue: string

  connect() {
    if (this.noticeValue) {
      this.noticeTarget.classList.remove("hidden")
    }

    if (this.alertValue) {
      this.alertTarget.classList.remove("hidden")
    }
  }

  closeNotice(event: Event) {
    this.noticeTarget.classList.add("hidden")
  }

  closeAlert(event: Event) {
    this.alertTarget.classList.add("hidden")
  }
}
